/**
 * Linhas de identificação do paciente (CPF e nascimento) empilhadas — cada uma
 * na própria linha — para os dropdowns de busca/seleção de paciente.
 *
 * Por que existe: a versão de linha única (`patientMetaLine`, "CPF · Nasc.")
 * truncava o nascimento nos dropdowns estreitos, escondendo justamente o dado
 * que diferencia homônimos. Empilhando, o trio nome / CPF / nascimento fica
 * sempre visível "um abaixo do outro" ao pesquisar — o mesmo padrão usado na
 * Lista de espera. Centralizar num componente garante que todos os seletores
 * de paciente do sistema exibam a informação igual.
 */

import { patientCpfLine, patientBirthLine } from '@/utils/patientCpf';
import type { Patient } from '@/types/models';

interface PatientMetaLinesProps {
  /** Paciente cujo CPF e nascimento serão exibidos. */
  p: Patient;
  /** Mostra o selo de cadastro incompleto na linha do nascimento. */
  incomplete?: boolean;
  /** Texto do selo (varia entre "Incompleto" e "Cadastro incompleto"). */
  incompleteLabel?: string;
  /** Classe das linhas (tamanho/cor do texto), igual à do título acima. */
  className?: string;
}

export function PatientMetaLines({
  p,
  incomplete = false,
  incompleteLabel = 'Incompleto',
  className = 'text-xs text-on-surface-variant truncate',
}: PatientMetaLinesProps) {
  return (
    <>
      <div className={className}>{patientCpfLine(p)}</div>
      <div className={className}>
        {patientBirthLine(p)}
        {incomplete && (
          <span className="ml-2 text-[10px] uppercase font-bold text-error">
            {incompleteLabel}
          </span>
        )}
      </div>
    </>
  );
}
